module.exports = __webpack_public_path__ + "img/logo-im-color.75e38865.webp";